import { render } from "./Receptions.vue?vue&type=template&id=f69a43e8"
import script from "./Receptions.vue?vue&type=script&lang=js"
export * from "./Receptions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__